import md5 from 'md5'
import CryptoJS from 'crypto-js'
import simpleCrypto from '@/helpers/crypto'

let expired = localStorage.getItem('xrd') ? localStorage.getItem('xrd') : ''
let dechiperText = localStorage.getItem('_pky') ? simpleCrypto.decrypt(localStorage.getItem('_pky')) : ''
let reqUrlGet = '/api/v1/orders/getdataorder'
let reqUrlOpen = '/api/v1/orders/openorder'

export function signature (dataBody, type) {
  let reqMethod = 'post'
  let reqBody = JSON.stringify(dataBody)
  let reqUrl
  if (type === 'getDataOrder') {
    reqUrl = reqUrlGet
  } else {
    reqUrl = reqUrlOpen
  }

  reqBody = reqBody !== '' ? md5(reqBody) : ''
  let reqSecret = reqMethod + '-' + reqBody.trim() + '-' + expired + '-' + reqUrl

  let hash = CryptoJS.HmacSHA256(reqSecret, dechiperText)
  let hashInBase64 = CryptoJS.enc.Base64.stringify(hash)

  return hashInBase64
}
